interface MembershipArrowIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/** Diagonal "Ahead" arrow glyph. Ported from Figma node 2:2978
 *  (Membership package tab). Two paths using currentColor for fill. */
export function MembershipArrowIcon({
  className,
  width = 12.2334,
  height = 13.01,
}: MembershipArrowIconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12.2334 13.01"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.36411 1.7561e-05H1.75065e-05V1.64094L9.29794 1.41277C10.1393 1.39246 10.8279 2.07226 10.8106 2.90679L10.6089 13.0024H12.2334V2.8474C12.2334 1.27525 10.9476 1.7561e-05 9.36254 1.7561e-05H9.36411Z"
        fill="currentColor"
      />
      <path
        d="M7.71597 3.54426L0 11.8161L1.17386 13.01L8.93394 4.66009C9.2475 4.32253 9.22229 3.79743 8.87722 3.49113C8.54003 3.19107 8.02322 3.21452 7.71597 3.54426Z"
        fill="currentColor"
      />
    </svg>
  );
}
